import React from 'react';
import PropTypes from 'prop-types';
import FilterPickerLanguage from './FilterPickerLanguage.js';
import FilterPickerGroup from './FilterPickerGroup.js';
import { tagGroupsSorted } from '../../../helpers/productTagFilter.js';
import { isFeatureOn } from '../../../helpers/featureFlag.js';

const FilterPicker = ({
  selectedTagsByGroup,
  onTagsChange,
  onContentLanguageChange,
  contentLanguage,
  showContentLanguagePicker,
  availableTagsByGroupName,
  enabledTagsByGroupName
}) => {
  // SUBSCRIPTIONS FEATURE FLAG
  const subscriptiosnOff = !isFeatureOn('subscriptions');
  return (
    <>
      {showContentLanguagePicker && (
        <FilterPickerLanguage
          onContentLanguageChange={onContentLanguageChange}
          contentLanguage={contentLanguage}
        />
      )}
      {
        tagGroupsSorted.map(groupName => {
          if (!availableTagsByGroupName[groupName] ||
            !availableTagsByGroupName[groupName].length) {
            return null;
          }

          if (subscriptiosnOff && groupName === 'Purchase type') {
            return null;
          }

          return (
            <FilterPickerGroup
              key={groupName}
              groupName={groupName}
              tags={availableTagsByGroupName[groupName]}
              selectedTags={selectedTagsByGroup[groupName]}
              enabledTags={enabledTagsByGroupName && enabledTagsByGroupName[groupName]}
              onTagClicked={onTagsChange}
              translateTags={groupName !== 'Author'}
            />
          );
        })
      }
    </>
  );
};

FilterPicker.propTypes = {
  selectedTagsByGroup: PropTypes.object.isRequired,
  availableTagsByGroupName: PropTypes.object.isRequired,
  onTagsChange: PropTypes.func.isRequired,
  showContentLanguagePicker: PropTypes.bool,
  enabledTagsByGroupName: PropTypes.object,
  contentLanguage: PropTypes.string,
  onContentLanguageChange: PropTypes.func
};

export default FilterPicker;
